var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 32,
    viewBox: "0 0 120 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4286 27.4286H0V9.14286L13.7143 0L27.4286 9.14286V27.4286Z",
    fill: "url(#paint0_linear_782_735)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7314 14.8571C57.2914 13.7143 55.0514 13.0629 52.0114 13.0629H44.2857V9.70286H59.2914V4.57143H37.4286V27.4286H51.9657C55.0133 27.4286 57.2571 26.7771 58.6971 25.4743C59.4434 24.7791 60.0278 23.9285 60.409 22.9825C60.7901 22.0365 60.9587 21.0183 60.9028 20C60.9589 19.0337 60.7922 18.0675 60.4157 17.1758C60.0393 16.2841 59.463 15.4909 58.7314 14.8571ZM53.2228 22.2971C52.3581 22.8849 51.315 23.1518 50.2743 23.0514H44.2857V17.1429H50.2857C51.3336 17.0372 52.3835 17.322 53.2343 17.9429C53.5202 18.2224 53.7435 18.5596 53.8892 18.932C54.035 19.3043 54.1001 19.7035 54.08 20.1029C54.1051 20.5089 54.0414 20.9156 53.8934 21.2945C53.7454 21.6735 53.5166 22.0156 53.2228 22.2971V22.2971Z",
    fill: "#2C2D2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9717 17.84C70.7774 18.1029 70.6402 18.2971 70.5488 18.4457L70.3202 18.8229H70.2517V4.57143H63.3945V27.4286H70.8688L80.8574 13.9429C81.0517 13.6686 81.1888 13.4514 81.2802 13.3029L81.5202 12.8457V13.28C81.5202 13.4171 81.5202 13.6571 81.5202 14.0114V27.4286H88.3774V4.57143H80.8574L70.9717 17.84Z",
    fill: "#2C2D2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.697 27.4286H119.715L107.589 15.3371L118.869 4.57143H110.206L101.532 12.9714H99.0745V4.57143H92.2288V27.4286H99.0745V18.48H101.646L110.697 27.4286Z",
    fill: "#2C2D2E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_782_735",
    x1: 0,
    y1: 0,
    x2: 27.4286,
    y2: 27.4286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0666667,
    stopColor: "#00CBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133333,
    stopColor: "#00CACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00C6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266667,
    stopColor: "#00C2CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#00BCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00B5CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466667,
    stopColor: "#00AECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533333,
    stopColor: "#00A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#009FCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#0098CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733333,
    stopColor: "#0092CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#008ECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866667,
    stopColor: "#008ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933333,
    stopColor: "#0089CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.55d27cd06f6404ec2771dbd4cb6f5ca0.svg";
export { ForwardRef as ReactComponent };